(function() {
  var koUtil,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  koUtil = require('resources/assets/coffee/Core/utils/knockout');

  exports.PopulationRange = (function(superClass) {
    extend(PopulationRange, superClass);

    function PopulationRange(handler, data) {
      var default_max_pop, default_min_pop, max_pop_limit, ref, ref1, ref2, ref3, ref4, ref5, ref6;
      PopulationRange.__super__.constructor.call(this);
      this.get_handler = function() {
        return handler;
      };
      this.get_original_data = function() {
        return data;
      };
      this.ignore(['use_custom_pop_range']);
      this.transform((function(_this) {
        return function(v, k) {
          if (_this.use_recommended_pop_range()) {
            if (k === 'planting_min_pop' || k === 'planting_max_pop') {
              return null;
            }
          }
          return v;
        };
      })(this));
      this.use_recommended_pop_range = ko.observable((ref = data.use_recommended_pop_range) != null ? ref : true);
      this.use_custom_pop_range = ko.computed((function(_this) {
        return function() {
          return _this.use_recommended_pop_range() === false;
        };
      })(this));
      switch (handler.parent.cropName) {
        case 'Soybeans':
          max_pop_limit = 400000;
          default_min_pop = (ref1 = data.default_min_pop) != null ? ref1 : 150000;
          default_max_pop = (ref2 = data.default_max_pop) != null ? ref2 : 250000;
          break;
        default:
          max_pop_limit = 60000;
          default_min_pop = (ref3 = data.default_min_pop) != null ? ref3 : 20000;
          default_max_pop = (ref4 = data.default_max_pop) != null ? ref4 : 40000;
      }
      this.planting_min_pop = ko.observable(null);
      this.planting_max_pop = ko.observable(null);
      koUtil.constrainValues(0, this.planting_min_pop);
      koUtil.constrainValues(this.planting_min_pop, this.planting_max_pop);
      koUtil.constrainValues(this.planting_max_pop, max_pop_limit);
      this.planting_min_pop((ref5 = data.planting_min_pop) != null ? ref5 : default_min_pop);
      this.planting_max_pop((ref6 = data.planting_max_pop) != null ? ref6 : default_max_pop);
      return this;
    }

    return PopulationRange;

  })(KoModel);

}).call(this);
